export default "__VITE_ASSET__$fOnJxRc__"